import React, { useState } from 'react'
import { Box } from '@mui/system'
import styled from '@emotion/styled' 
import { Avatar, Button, Checkbox, Divider, FormControlLabel, TextField, Typography } from '@mui/material'
import { useFormik } from "formik";
import * as yup from "yup";
import { useNavigate, useSearchParams } from 'react-router-dom';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
const StyledForm=styled("form")(({theme})=>({
  padding:'20px',
  display:'flex',
  flexDirection:'column',
  gap:'20px',
}))
const SignInCard=styled(Box)(({theme})=>({
    width:'55%',
    height:'40%',
    background:theme.palette.background.default,
    boxShadow: `0px 0px 7px ${theme.palette.background.shadow}`,
    borderRadius:'10px',
    padding:'10px',
    margin:'10% 25%',
    display:'flex',
    flexDirection:'column',
    justifyContent:'space-between',
    alignItems:'center'
}))
const LogoContainer = styled('span')(({theme})=>({
    display: 'flex',
    gap: '5px',
    alignItems: 'center',
    justifyContent:'center',
    cursor:'pointer',
    span: {
        fontSize: '34px',
        fontWeight: '600',
    },
    marginLeft:'10px',
    paddingBottom:'40px',
    borderBottom: `0.5px solid ${theme.palette.third.light}`,
}))
const Header=styled(Box)(({theme})=>({
    display:'flex',
    justifyContent:'center',
    alignItems:'center',
    padding:"15px",
    color: theme.palette.third.main,
    fontWeight: '400',
    fontSize: '17px',
}))

export default function ConfirmResearchMember() {
  const [searchParams, setSearchParams] = useSearchParams();
  const __r=searchParams.get("__r");
  const __e=searchParams.get("__e");
  const __i=searchParams.get("__i");
  const __ro=searchParams.get("__ro");
  const navigate=useNavigate()
  const api=useAxiosPrivate()
const accept=async ()=>{
  api.post('research/addMember',{research_id:__i,role:__ro}).
  then(()=>{
    navigate('/researches', {state:{id:__i,message:"You are now a member of this research"}})

  })
}

  return (
        <SignInCard>
             <LogoContainer >
                <Avatar src="/images/aastulogo.png" sx={{ width: 40, height: 40 }} />
                <span>ALMS</span>
            </LogoContainer>
            <Header>
                You have been invited to join the research "{__r}"
            </Header>
              <Button
              type="submit"
              size="large"
              onClick={()=>accept()}
              sx={{
                   bgcolor:'secondary.main',
                   fontWeight: 400,
                   color:'#fff',
                   width:'60%',
                  "&:hover":{
                   bgcolor:'secondary.hover',}, } }
              >
                Accept
              </Button>
            <Divider/>
        </SignInCard>
  )
}
